import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex align-items-center flex-nowrap" }

import TokenIcon from './TokenIcon.vue';
import TokenPairText from './TokenPairText.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenPairIcon',
  props: {
    tokenA: null,
    tokenB: null,
    size: null,
    full: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tokenA: Record<string, any>;
  tokenB: Record<string, any>;
  size?: string;
  full?: boolean;
}



const style = computed(() => (props.size ? `margin-left: -${+props.size / 4}px` : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TokenIcon, {
      "icon-src": __props.tokenA.tokenIconUrl,
      symbol: __props.tokenA.symbol,
      size: __props.size,
      class: "token-border"
    }, null, 8, ["icon-src", "symbol", "size"]),
    _createVNode(TokenIcon, {
      "icon-src": __props.tokenB.tokenIconUrl,
      symbol: __props.tokenB.symbol,
      size: __props.size,
      style: _normalizeStyle(_unref(style)),
      class: "token-border"
    }, null, 8, ["icon-src", "symbol", "size", "style"]),
    (__props.full)
      ? (_openBlock(), _createBlock(TokenPairText, {
          key: 0,
          "token-a-symbol": __props.tokenA.symbol,
          "token-b-symbol": __props.tokenB.symbol,
          class: "ml-s1 text-sm"
        }, null, 8, ["token-a-symbol", "token-b-symbol"]))
      : _createCommentVNode("", true)
  ]))
}
}

})